export const formatDeliveryModes = (modes: string[]): string => {
  if (modes.length === 0) return '';
  if (modes.length === 1) return modes[0]!;
  if (modes.length === 2) return `${modes[0]} and ${modes[1]}`;

  return `${modes.slice(0, -1).join(', ')} and ${modes[modes.length - 1]}`;
};

export const formatLocations = (locations: string[]): string => {
  if (locations.length === 0) return '';
  if (locations.length === 1) return locations[0]!;
  if (locations.length === 2) return `${locations[0]} & ${locations[1]}`;

  return `${locations.slice(0, -1).join(', ')} & ${locations[locations.length - 1]}`;
};
